import React, { useState, useEffect } from "react";
import { Product } from './product';

export const ProductCategories = (props) => {

    const [expandedCategory, setExpandedCategory] = useState(null);

    useEffect(() => {
        // Set the first category as expanded by default when the component mounts
        if (props.data && props.data.length > 0) {
            setExpandedCategory(props.data[0].categoryName); // Expanding the first category
        }
    }, [props.data]); // Only run when props.data is available

    const handleToggle = (categoryName) => {

        setExpandedCategory(expandedCategory === categoryName ? null : categoryName);
    };

    return (
        <div className="container">
            <div id="productcategories">
            <div className="section-title" class="text-center">
                <h2>Products</h2>
            </div>
            {props.data
                ? props.data.map((category) => (
                <div key={category.categoryName} className="product-category">
                    <div className="category-header" onClick={() => handleToggle(category.categoryName)} style={{cursor: 'pointer'}}>
                            <h3 className="category-name">{category.categoryName}</h3>
                            <span className="toggle-arrow">{expandedCategory === category.categoryName ? '▲' : '▼'}</span>
                    </div>
                    {expandedCategory === category.categoryName && (
                        <div className="product-container">
                        {category.products
                        ? category.products.map((product) => (
                            <Product
                                key={product.id}
                                name={product.name}
                                imageUrl={product.imageUrl}
                                description={product.description}
                            />
                        )): "Loading..."}
                        </div>
                    )}
                </div>
                )) : "Loading..."}
            </div>
        </div>
      );
  };